import * as React from "react"

const IconTableDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      d="M8.002 12a1 1 0 0 1-.708-.294l-5-5a1 1 0 0 1 1.415-1.413l4.293 4.292 4.292-4.292a1.001 1.001 0 0 1 1.632 1.09.998.998 0 0 1-.217.323l-5 5a.998.998 0 0 1-.707.294Z"
      fill="#4F4FFF"
    />
  </svg>
)

export default IconTableDown
